/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Link } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { BarsIcon } from "../../FontAwesome";
import ViewMenuModel from "./ViewMenuModel";
import ViewMenuProps from "./ViewMenuProps";
import "./ViewMenu.scss";

export default function ViewMenu(props: ViewMenuProps) {
    const vm = new ViewMenuModel(props);
    return (
        <div className="lan-viewmenu">
            <IconButton className="lan-viewmenu__iconbutton" onClick={vm.oeffneMenu} size="large">
                <BarsIcon />
            </IconButton>
            <Menu anchorEl={vm.anchorElement} open={vm.isOpen} onClose={vm.schliesseMenu}>
                {vm.items.map((item, index) => (
                    <MenuItem
                        key={index}
                        component={Link}
                        to={item.to}
                        replace
                        onClick={vm.schliesseMenu}
                    >
                        {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                        {item.caption}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
